import axios from '../../../config/axiosConfig';
import { ErrorResponse } from '../../../shared';
import { ExitDigitalTestResponse, ReportArgumentResponse } from './ResultReport.interfaces';

export const fetchReportArguments = async(url: string): Promise<ReportArgumentResponse|ErrorResponse> => {
  const body = {
    url: url
  };
  const response = await axios.post('api/report/ReportArguments', body)
    .then(res => res.data)
    .then((reports): ReportArgumentResponse => ({
      __typename: 'ReportArgumentResponse',
      reports
    }))
    .catch((errMsg: string):ErrorResponse => ({
      __typename: 'ErrorResponse',
      errMsg
    }));
  return response;
};

export const fetchAdminAndStudentIDs = async(testTicketID: string):
  Promise<ExitDigitalTestResponse|ErrorResponse> => {
  const request = {
    TestTicketID: testTicketID
  };
  const response = await axios.post('api/testLaunch/ExitDigitalTest',
    request,
    {
      headers: {
        'content-type': 'application/json'
      }
    })
    .then(res => res.data)
    .then((results): ExitDigitalTestResponse => ({
      __typename: 'ExitDigitalTestResponse',
      administrationID: results.administrationID,
      studentID: results.studentID,
    }))
    .catch((errMsg: string):ErrorResponse => ({
      __typename: 'ErrorResponse',
      errMsg
    }));
  return response;
};